import { getType } from "typesafe-actions";
import { Actions, StoreState, actions } from "../utils";

export type Theme = 'default' | 'red'| 'red2'| 'blue'| 'darkblue'| 'smokeblue'| 'gold'| 'green'| 'orange'| 'teal'| 'violet'| 'lime';

export const defaultIpfx = {
   theme: 'default' as Theme,
   dark: false
}

export default function ipfx(state = defaultIpfx, action: Actions) {
   if (action.type === getType(actions.setIpfx)) {
     return action.payload
   }
   return state
 }

export function selectIpfx(state: StoreState) { return state.ipfx }


